import { en } from './languages/en';
import { nl } from './languages/nl';
import { de } from './languages/de';
import { fr } from './languages/fr';
import { dk } from './languages/dk';
import { it } from './languages/it';
import { es } from './languages/es';

export const defaultAppTexts = { en, nl, de, dk, fr, it, es };
